'use client';

import { createContainer } from '@mui/system';
import capitalize from "../utils/capitalize.js";
import styled from "../styles/styled.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
var Container = createContainer({
  createStyledComponent: styled('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      var ownerState = props.ownerState;
      return [styles.root, styles["maxWidth".concat(capitalize(String(ownerState.maxWidth)))], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
    }
  }),
  useThemeProps: function useThemeProps(inProps) {
    return useDefaultProps({
      props: inProps,
      name: 'MuiContainer'
    });
  }
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Container;